module.exports = __webpack_public_path__ + "fonts/Inter-Regular.8c206db.woff";